"use client";

import { useState } from 'react';

export default function MarketResearchDashboardsSection() {
  const [activeTab, setActiveTab] = useState(0);

  const dashboards = [
    {
      title: 'EXECUTIVE INSIGHTS DASHBOARD',
      subtitle: 'Research Executive Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Executive Insights Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {[
            { x: 16, label: 'Active Project Pipeline', value: '₹287Cr', sub: '+12.4% YoY', color: '#1B2845' },
            { x: 186, label: 'Project Win Rate', value: '68%', sub: '+4.2% vs LY', color: '#16a34a' },
            { x: 356, label: 'Avg Insight Delivery', value: '4.2 days', sub: '↓ 1.8 days MoM', color: '#C5A572' },
            { x: 526, label: 'Client Retention', value: '91%', sub: 'Target: 88%', color: '#1B2845' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="16" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
              <text x={kpi?.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi?.sub}</text>
            </g>
          ))}

          {/* Research Revenue Trend */}
          <rect x="16" y="136" width="420" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Research Revenue Trends (₹Cr)</text>
          <polyline points="40,290 80,278 120,270 160,258 200,262 240,245 280,238 320,230 360,222 400,215 420,210" fill="none" stroke="#1B2845" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          <polyline points="40,290 80,278 120,270 160,258 200,262 240,245 280,238 320,230 360,222 400,215 420,210 420,310 40,310 Z" fill="#1B2845" opacity="0.05" />
          {[40,80,120,160,200,240,280,320,360,400,420]?.map((x, i) => (
            <circle key={i} cx={x} cy={[290,278,270,258,262,245,238,230,222,215,210]?.[i]} r="3" fill="#C5A572" />
          ))}

          {/* Client Performance by Revenue */}
          <rect x="448" y="136" width="236" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="460" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Top Clients by Revenue</text>
          {[
            { client: 'Client A', rev: 48, color: '#1B2845' },
            { client: 'Client B', rev: 42, color: '#C5A572' },
            { client: 'Client C', rev: 36, color: '#3b82f6' },
            { client: 'Client D', rev: 28, color: '#8b5cf6' },
            { client: 'Client E', rev: 22, color: '#10b981' },
          ]?.map((item, i) => (
            <g key={i}>
              <text x="460" y={178 + i * 24} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{item?.client}</text>
              <rect x="530" y={166 + i * 24} width={item?.rev * 2.8} height="12" fill={item?.color} rx="2" opacity="0.75" />
              <text x="536" y={176 + i * 24} fill="white" fontSize="8" fontWeight="bold" fontFamily="sans-serif">₹{item?.rev}Cr</text>
            </g>
          ))}

          {/* Market Trend Summary */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Market Trend Summary Cards</text>
          {[
            { trend: 'Digital Adoption', change: '+24%', color: '#16a34a', bg: '#f0fdf4' },
            { trend: 'Brand Awareness', change: '+18%', color: '#C5A572', bg: '#fefce8' },
            { trend: 'Consumer Trust', change: '+12%', color: '#3b82f6', bg: '#eff6ff' },
            { trend: 'Price Sensitivity', change: '+8%', color: '#8b5cf6', bg: '#f5f3ff' },
          ]?.map((item, i) => (
            <g key={i}>
              <rect x={28 + i * 165} y="352" width="155" height="44" rx="6" fill={item?.bg} />
              <text x={38 + i * 165} y="368" fill="#374151" fontSize="9" fontFamily="sans-serif">{item?.trend}</text>
              <text x={38 + i * 165} y="384" fill={item?.color} fontSize="13" fontWeight="bold" fontFamily="sans-serif">{item?.change}</text>
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'RESEARCH ANALYTICS DASHBOARD',
      subtitle: 'Consumer Behavior & Brand Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Research Analytics Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {[
            { x: 16, label: 'Survey Completion Rate', value: '74%', sub: '+6.2% vs LY', color: '#16a34a' },
            { x: 186, label: 'Consumer Panels Active', value: '48,200', sub: '12 active studies', color: '#1B2845' },
            { x: 356, label: 'Avg NPS Score', value: '62', sub: 'Industry avg: 48', color: '#C5A572' },
            { x: 526, label: 'Cross-Study Insights', value: '284', sub: 'This quarter', color: '#1B2845' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="16" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
              <text x={kpi?.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi?.sub}</text>
            </g>
          ))}

          {/* Consumer Behavior Trend */}
          <rect x="16" y="136" width="420" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Consumer Behavior Trend (12-Month)</text>
          <polyline points="40,290 80,275 120,268 160,255 200,260 240,242 280,235 320,228 360,220 400,212 420,208" fill="none" stroke="#C5A572" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          <polyline points="40,290 80,275 120,268 160,255 200,260 240,242 280,235 320,228 360,220 400,212 420,208 420,310 40,310 Z" fill="#C5A572" opacity="0.06" />
          {[40,80,120,160,200,240,280,320,360,400,420]?.map((x, i) => (
            <circle key={i} cx={x} cy={[290,275,268,255,260,242,235,228,220,212,208]?.[i]} r="3" fill="#1B2845" />
          ))}
          {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov']?.map((m, i) => (
            <text key={i} x={[40,80,120,160,200,240,280,320,360,400,420]?.[i] - 6} y="308" fill="#9ca3af" fontSize="7" fontFamily="sans-serif">{m}</text>
          ))}

          {/* Brand Performance */}
          <rect x="448" y="136" width="236" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="460" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Brand Performance Index</text>
          {[
            { brand: 'Brand A', score: 84, color: '#1B2845' },
            { brand: 'Brand B', score: 76, color: '#C5A572' },
            { brand: 'Brand C', score: 68, color: '#3b82f6' },
            { brand: 'Brand D', score: 72, color: '#8b5cf6' },
            { brand: 'Brand E', score: 61, color: '#10b981' },
          ]?.map((item, i) => (
            <g key={i}>
              <text x="460" y={178 + i * 24} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{item?.brand}</text>
              <rect x="530" y={166 + i * 24} width={item?.score * 1.4} height="12" fill={item?.color} rx="2" opacity="0.75" />
              <text x="536" y={176 + i * 24} fill="white" fontSize="8" fontWeight="bold" fontFamily="sans-serif">{item?.score}</text>
            </g>
          ))}

          {/* Cross-Study Comparison */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Cross-Study Comparison — NPS / CSAT / Awareness</text>
          {[
            { study: 'Study Q1 2024', nps: 58, csat: 72, aware: 64 },
            { study: 'Study Q2 2024', nps: 62, csat: 75, aware: 68 },
            { study: 'Study Q3 2024', nps: 65, csat: 78, aware: 71 },
            { study: 'Study Q4 2024', nps: 68, csat: 80, aware: 74 },
          ]?.map((item, i) => (
            <g key={i}>
              <text x={28 + i * 165} y="362" fill="#6b7280" fontSize="8" fontFamily="sans-serif">{item?.study}</text>
              <rect x={28 + i * 165} y="366" width={item?.nps * 0.8} height="5" fill="#1B2845" rx="1" opacity="0.7" />
              <rect x={28 + i * 165} y="373" width={item?.csat * 0.8} height="5" fill="#C5A572" rx="1" opacity="0.7" />
              <rect x={28 + i * 165} y="380" width={item?.aware * 0.8} height="5" fill="#3b82f6" rx="1" opacity="0.7" />
            </g>
          ))}
        </svg>
      ),
    },
    {
      title: 'OPERATIONS PERFORMANCE DASHBOARD',
      subtitle: 'Research Operations Intelligence',
      svg: (
        <svg viewBox="0 0 700 420" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <rect width="700" height="420" fill="#F8F6F3" rx="12" />
          <rect width="700" height="44" fill="#1B2845" rx="12" />
          <rect x="0" y="32" width="700" height="12" fill="#1B2845" />
          <text x="20" y="28" fill="white" fontSize="13" fontWeight="bold" fontFamily="sans-serif">Operations Performance Dashboard</text>
          <text x="580" y="28" fill="#C5A572" fontSize="11" fontFamily="sans-serif">Live ●</text>

          {[
            { x: 16, label: 'Analyst Productivity', value: '87%', sub: '+5.4% MoM', color: '#16a34a' },
            { x: 186, label: 'On-Time Delivery', value: '92%', sub: 'Target: 90%', color: '#1B2845' },
            { x: 356, label: 'Panel Engagement Rate', value: '68%', sub: '+3.2% vs LY', color: '#C5A572' },
            { x: 526, label: 'Active Projects', value: '34', sub: '8 at-risk', color: '#d97706' },
          ]?.map((kpi, i) => (
            <g key={i}>
              <rect x={kpi?.x} y="56" width="158" height="68" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
              <text x={kpi?.x + 12} y="76" fill="#6b7280" fontSize="9" fontFamily="sans-serif">{kpi?.label}</text>
              <text x={kpi?.x + 12} y="96" fill={kpi?.color} fontSize="16" fontWeight="bold" fontFamily="sans-serif">{kpi?.value}</text>
              <text x={kpi?.x + 12} y="114" fill="#9ca3af" fontSize="9" fontFamily="sans-serif">{kpi?.sub}</text>
            </g>
          ))}

          {/* Project Timeline Status */}
          <rect x="16" y="136" width="420" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Project Delivery Status</text>
          {[
            { proj: 'Consumer Segmentation Study', status: 'On Track', color: '#16a34a', bg: '#f0fdf4', pct: 78 },
            { proj: 'Brand Awareness Q4', status: 'On Track', color: '#16a34a', bg: '#f0fdf4', pct: 92 },
            { proj: 'Market Entry Analysis', status: 'At Risk', color: '#d97706', bg: '#fffbeb', pct: 45 },
            { proj: 'Competitor Benchmarking', status: 'Delayed', color: '#dc2626', bg: '#fef2f2', pct: 28 },
            { proj: 'NPS Tracking Study', status: 'On Track', color: '#16a34a', bg: '#f0fdf4', pct: 65 },
          ]?.map((item, i) => (
            <g key={i}>
              <rect x="28" y={163 + i * 28} width="380" height="22" rx="4" fill={item?.bg} />
              <text x="38" y={178 + i * 28} fill="#374151" fontSize="9" fontFamily="sans-serif">{item?.proj}</text>
              <rect x="280" y={165 + i * 28} width={item?.pct * 0.9} height="18" fill={item?.color} rx="3" opacity="0.2" />
              <text x="286" y={178 + i * 28} fill={item?.color} fontSize="8" fontWeight="bold" fontFamily="sans-serif">{item?.pct}%</text>
              <text x="360" y={178 + i * 28} fill={item?.color} fontSize="8" fontWeight="bold" fontFamily="sans-serif">{item?.status}</text>
            </g>
          ))}

          {/* Operational Cost by Project Type */}
          <rect x="448" y="136" width="236" height="180" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="460" y="156" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Cost by Project Type (₹Cr)</text>
          {[
            { type: 'Quantitative', cost: 42, color: '#1B2845' },
            { type: 'Qualitative', cost: 28, color: '#C5A572' },
            { type: 'Tracking', cost: 35, color: '#3b82f6' },
            { type: 'Ad-hoc', cost: 18, color: '#8b5cf6' },
            { type: 'Syndicated', cost: 22, color: '#10b981' },
          ]?.map((item, i) => (
            <g key={i}>
              <text x="460" y={178 + i * 24} fill="#6b7280" fontSize="9" fontFamily="sans-serif">{item?.type}</text>
              <rect x="548" y={166 + i * 24} width={item?.cost * 2.4} height="12" fill={item?.color} rx="2" opacity="0.75" />
              <text x="554" y={176 + i * 24} fill="white" fontSize="8" fontWeight="bold" fontFamily="sans-serif">₹{item?.cost}Cr</text>
            </g>
          ))}

          {/* Panel Engagement Trend */}
          <rect x="16" y="328" width="668" height="80" fill="white" rx="8" stroke="#e5e7eb" strokeWidth="1" />
          <text x="28" y="346" fill="#1B2845" fontSize="11" fontWeight="bold" fontFamily="sans-serif">Panel Engagement Rate — Monthly Trend (%)</text>
          <polyline points="40,380 120,372 200,368 280,360 360,355 440,348 520,342 600,338 668,334" fill="none" stroke="#C5A572" strokeWidth="2" strokeLinecap="round" />
          {[40,120,200,280,360,440,520,600,668]?.map((x, i) => (
            <circle key={i} cx={x} cy={[380,372,368,360,355,348,342,338,334]?.[i]} r="3" fill="#1B2845" />
          ))}
          {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep']?.map((m, i) => (
            <text key={i} x={[40,120,200,280,360,440,520,600,668]?.[i] - 6} y="395" fill="#9ca3af" fontSize="7" fontFamily="sans-serif">{m}</text>
          ))}
        </svg>
      ),
    },
  ];

  return (
    <section className="py-24 bg-cream px-4 sm:px-6 lg:px-8 xl:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-navy text-2xl sm:text-3xl md:text-4xl xl:text-[3rem] leading-[1.2] font-bold mb-4">
            Role-Specific Intelligence for <span className="italic">Research Leaders</span>
          </h2>
          <p className="text-charcoal/70 text-lg max-w-2xl mx-auto">Real-time dashboards built for every level of research leadership.</p>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap gap-3 justify-center mb-10">
          {dashboards?.map((d, i) => (
            <button
              key={i}
              onClick={() => setActiveTab(i)}
              className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-all duration-300 ${
                activeTab === i
                  ? 'bg-navy text-white shadow-md'
                  : 'bg-white text-navy border border-gray-200 hover:border-gold/40'
              }`}
            >
              {d?.title}
            </button>
          ))}
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-8 border border-gray-200 shadow-sm">
          <div className="mb-4">
            <h3 className="font-serif text-navy text-xl font-bold">{dashboards?.[activeTab]?.subtitle}</h3>
          </div>
          <div className="w-full aspect-[700/420] rounded-xl overflow-hidden border border-gray-100">
            {dashboards?.[activeTab]?.svg}
          </div>
        </div>
      </div>
    </section>
  );
}
